import { components } from "@/lib/ApiSchema";
import $api from "@/lib/queries/openapi";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

export function useReuseFieldValue({
  operationType,
  operationName,
  keyPath,
}: {
  operationType: components["schemas"]["CalculatorTypeEnum"];
  operationName: string;
  keyPath: readonly PropertyKey[];
}) {
  const { teamSlug } = useParams();
  const queryClient = useQueryClient();

  const apiPath = "/api/teams/{team_slug}/reuse_field_value";
  const params = { path: { team_slug: teamSlug! } };

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ["get", apiPath],
    });
  };

  const { data: reuseFields } = $api.useQuery("get", apiPath, {
    params: {
      ...params,
      query: {
        operation_type: operationType,
        operation_name: operationName,
      },
    },
  });
  const { mutate: remove } = $api.useMutation("delete", apiPath, { onSuccess });
  const { mutate: add } = $api.useMutation("post", apiPath, { onSuccess });

  const body = {
    operation_type: operationType,
    operation_name: operationName,
    field_path: keyPath.join("."),
  };
  const markedForReuse = reuseFields?.includes(keyPath.join("."));

  return {
    markedForReuse,
    toggleFieldReuse: () => {
      if (markedForReuse) {
        remove({ params, body });
      } else {
        add({ params, body });
      }
    },
  };
}
